var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',_vm._l((_vm.commentList),function(item){return _c('comment-item',{key:item.pid,attrs:{"item":item,"level":_vm.level},on:{"spot":function($event){return _vm.spot(arguments)}},scopedSlots:_vm._u([{key:"content",fn:function(ref){
var row = ref.row;
var childLevel = ref.childLevel;
return [(row.subComments && row.subComments.length > 0)?[_c('comment-list',{attrs:{"comments":row.subComments,"level":childLevel}})]:_vm._e()]}}],null,true)})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-474b1808","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/commentList/commentList.vue
// module id = null
// module chunks = 